import React from 'react'

const CoreComponentProduct = ({technical,feature,feature2,feature3}) => {
  return (
    <div>
           <div>
            <div className="row mt-4">
              {(technical ? feature : feature2).map((val, i) => (
                <div className="col-lg-6  mb-4" key={i}>
                  <div className="d-flex h-100">
                    <div className="bg-black d-flex justify-content-center px-2 rounded-5">
                      <img
                        src={val.icon}
                        className=" text-center"
                        alt=""
                        style={{ height: 50, width: 50 }}
                      />
                    </div>
                    <div className="w-100 ms-3 rounded-5 border px-3 py-3  border-light">
                      <h4 className="h3-heading fw-semibold">{val.title} </h4>
                      <p className="mt-2 h3-para lh-base">{val.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
    </div>
  )
}

export default CoreComponentProduct